<div class="title">
  <h2>{{ 'faq.title' | translate }}</h2>
  <aside>{{ 'faq.secondary' | translate }}</aside>
</div>
<div class="items">
  @for (issue of data; track $index) {
    <div class="item" (click)="issue.selected = !issue.selected">
      <div class="issue">
        <div class="item-issue">
          <h3>{{ issue.issue | translate }}</h3>
        </div>
        <div class="item-icon">
          <span>{{ !issue.selected ? '+' : '-' }}</span>
        </div>
      </div>

      @if (issue.selected) {
        <hr class="item-hr" />
      }
      <div class="reply" [ngClass]="issue.selected ? 'active' : ''">
        <p class="story">{{ issue.reply | translate }}</p>
      </div>
    </div>
  }
</div>

<div class="help">
  <div class="contain">
    <h4>{{ 'menu.footer.help' | translate }}</h4>
    <span>{{ 'menu.footer.supportContact' | translate }}</span>
    <a [href]="supportSafeLink" class="btn-primary">
      {{ 'menu.footer.seeCustomer' | translate }}
    </a>
  </div>
  <div class="help-img"></div>
</div>
